import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-switch",
  "use": "icon-switch-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-switch\"><path d=\"M320 832a320 320 0 0 1 0-640h384a320 320 0 0 1 0 640zM704 256H320a256 256 0 0 0 0 512h384a256 256 0 0 0 0-512z\" p-id=\"7025\" /><path d=\"M320 704a192 192 0 1 1 192-192 192 192 0 0 1-192 192z m0-320a128 128 0 1 0 128 128 128 128 0 0 0-128-128z\" p-id=\"7026\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol